"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var FaqItemShowWrapper = function FaqItemShowWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this$props$route, _this$props$params;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      var id = _this.props.params ? _this.props.params.faqItemId : (_this$props$route = _this.props.route) === null || _this$props$route === void 0 || (_this$props$route = _this$props$route.params) === null || _this$props$route === void 0 ? void 0 : _this$props$route.faqItemId;
      _state.AppUI.faqItemStore.getShow({
        ids: {
          faqItemId: id
        }
      }, _this.afterGetFaqItem);
      if ((_this$props$params = _this.props.params) !== null && _this$props$params !== void 0 && _this$props$params.faqCategoryId) {
        _state.AppUI.faqCategoryStore.getShow({
          ids: {
            faqCategoryId: _this.props.params.faqCategoryId
          }
        });
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "faqItem",
      get: function get() {
        return _state.AppUI.faqItemStore.showData;
      }
    }, {
      key: "forumThread",
      get: function get() {
        return _state.ForumUI.forumThreadStore.showData;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.faqItemStore.clearShowData();
        _state.ForumUI.forumThreadStore.clearShowData();
      }
    }, {
      key: "afterGetFaqItem",
      value: function afterGetFaqItem(resp) {
        _state.AppUI.faqItemStore.setShowData(resp);
        if (this.faqItem.forumThreadId) {
          this.loadForumThread(this.faqItem.forumThreadId);
        }
      }
    }, {
      key: "loadForumThread",
      value: function loadForumThread(id) {
        _state.ForumUI.forumThreadStore.getShow({
          ids: {
            forumThreadId: id
          }
        }, this.afterLoadForumThread);
      }
    }, {
      key: "afterLoadForumThread",
      value: function afterLoadForumThread(resp) {
        _state.ForumUI.forumThreadStore.setShowData(resp);
      }
    }, {
      key: "afterEmbeddedCommentCreate",
      value: function afterEmbeddedCommentCreate() {
        this.loadForumThread(this.faqItem.forumThreadId);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          faqItem: this.faqItem,
          faqCategory: _state.AppUI.faqCategoryStore.showData,
          forumThread: this.forumThread,
          afterEmbeddedCommentCreate: this.afterEmbeddedCommentCreate
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "faqItem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "faqItem"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "forumThread", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "forumThread"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetFaqItem", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetFaqItem"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadForumThread"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterLoadForumThread", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterLoadForumThread"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterEmbeddedCommentCreate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterEmbeddedCommentCreate"), _class2.prototype), _class2)) || _class;
};
FaqItemShowWrapper.displayName = 'FaqItemShowWrapper';
var _default = exports["default"] = FaqItemShowWrapper;